import { StoreState } from '@/redux/types';

export const getDraft = (state: StoreState) => state.draft;
